import publicConfig from "config/public";

const {
  imgix: { publicUrl },
} = publicConfig;

const basePath = "/brands/product-categories";

export type CategoryImageMapType = {
  [index: string]: string;
};

export const BRAND_CATEGORY_IMAGE_MAP: CategoryImageMapType = Object.freeze({
  Apparel: `${publicUrl}${basePath}/apparel.jpg`,
  "Books & Games": `${publicUrl}${basePath}/books-games.jpg`,
  Cannabis: `${publicUrl}${basePath}/cannabis.jpg`,
  Concentrates: `${publicUrl}${basePath}/concentrates.jpg`,
  Dabbing: `${publicUrl}${basePath}/dabbing.jpg`,
  "Delta-8 THC": `${publicUrl}${basePath}/delta-8-thc.jpg`,
  Edibles: `${publicUrl}${basePath}/edibles.jpg`,
  Growing: `${publicUrl}${basePath}/growing.jpg`,
  "Hemp CBD": `${publicUrl}${basePath}/hemp-cbd.jpg`,
  Other: `${publicUrl}${basePath}/other.jpg`,
  Pets: `${publicUrl}${basePath}/pets.jpg`,
  Services: `${publicUrl}${basePath}/services.jpg`,
  Smoking: `${publicUrl}${basePath}/smoking.jpg`,
  Storage: `${publicUrl}${basePath}/storage.jpg`,
  Topicals: `${publicUrl}${basePath}/topicals.jpg`,
  Tourism: `${publicUrl}${basePath}/tourism.jpg`,
  Vaping: `${publicUrl}${basePath}/vaping.jpg`,
});
